<template>
  <div class="container-width">
    <ul class="ny-news01">
      <li
        v-for="(item, index) in listData"
        :key="index"
        @click="goArticle(item)"
      >
        <!-- <div class="tu1" v-if="item.img">
          <img src="" :alt="item.title" />
        </div> -->
        <div class="r01">
          <a :title="item.title">
            <h2>{{ item.title }}</h2>
          </a>
          <p
            v-if="item.description && showDescription"
            v-html="item.description.replace(/<\/?.+?\/?>/g, '')"
          ></p>
        </div>
        <div class="l01">
          <div class="n-day">{{ item.releaseDate.split("-")[2] }}</div>
          <div class="n-month">
            {{ item.releaseDate.split("-")[0] }}-{{
              item.releaseDate.split("-")[1]
            }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
    
<script>
import config from "../config/dev";
export default {
  name: "LIST",
  props: {
    listData: {
      type: Array,
      default: [],
    },
    articlePath: {
      type: String,
      default: "",
    },
    channelName: {
      type: String,
      default: "",
    },
    showDescription: {
      // 是否显示简介
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    init() {
      if (this.listData.length) {
        this.listData.map((item) => {
          item.year = item.releaseDate.split("-")[0];
          item.day =
            item.releaseDate.split("-")[1] +
            "-" +
            item.releaseDate.split("-")[2];
          if (item.img) {
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          }
        });
      }
    },

    goArticle(e) {
      let parmes = {};
      if (this.channelName) {
        parmes = {
          id: e.id,
          channelName: this.channelName,
        };
      } else {
        parmes = {
          id: e.id,
        };
      }

      if (e.url && e.url.length) {
        window.open(e.url, "_blank");
      } else {
        // let articlePath = this.articlePath;
        this.$router.push({
          path: this.articlePath,
          query: parmes,
        });

        // const { href } = this.$router.resolve({
        //   path: `${articlePath}/${articleId}`,
        // });
        // window.open(href, "_self");
      }
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.news {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  border-bottom: 1px dashed #f5f5f5;
  padding: 30px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  .nl {
    width: 100px;
    height: 80px;
    background-color: #eee;
    padding-top: 20px;
    margin-right: 30px;
    div {
      text-align: center;
      font-size: 1rem;
      line-height: 30px;
      width: 100px;
      color: #00479d;
    }
  }
  .nr {
    height: 80px;
    display: -webkit-flex;
    display: flex;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    .title {
      font-size: 1.4rem;
      color: #323232;
    }
    .description {
      color: #808080;
      font-size: 0.9rem;
    }
  }
}
.news:hover {
  background: #00479d;
  color: #ffffff;
  .nl {
    color: #00479d;
  }
  .nr {
    .title {
      color: #ffffff;
    }
  }
  .description {
    color: #ffffff;
  }
}
.ny-news01 {
  width: 100%;
  height: auto;
  li {
    padding: 20px 0px;
    width: 100%;
    border-bottom: 1px dashed #dedddd;
    overflow: hidden;
    display: -webkit-flex;
    display: flex;
    cursor: pointer;
    .tu1 {
      width: 185px;
      height: 130px;
      overflow: hidden;
      border: 1px solid #efefef;
      margin-right: 30px;
      img {
        width: 185px;
        height: 130px;
        overflow: hidden;
        transition: all 0.5s ease-out;
        -webkit-transform: scale(1, 1);
        -moz-transform: scale(1, 1);
        -webkit-transition: all 0.5s ease-out;
        -moz-transition: all 0.5s ease-out;
      }
    }
    .l01 {
      margin-left: 15px;
      width: 92px;
      height: 100px;
      border-right: 1px solid #efefef;
      border-left: 1px solid #efefef;
      .n-day {
        width: 100%;
        height: 57px;
        font-size: 45px;
        color: #555;
        text-align: center;
        line-height: 57px;
        font-family: "Impact";
        letter-spacing: 0px;
        transition: all 0.4s ease-in-out;
      }
      .n-month {
        width: 100%;
        font-size: 15px;
        color: #555;
        text-align: center;
        letter-spacing: 0px;
      }
    }
    .r01 {
      flex: 1;
      height: auto;
      // height: 100px;
      display: -webkit-flex;
      display: flex;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-justify-content: center;
      justify-content: center;

      h2 {
        display: block;
        // height: 36px;
        font-size: 1.2rem;
        color: #555;
        letter-spacing: 0px;
        transition: all 0.3s ease-in-out;
      }
      p {
        display: block;
        font-size: 14px;
        color: #555;
        letter-spacing: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 10px;
      }
    }
  }
  li:hover {
    .r01 {
      h2 {
        color: #00479d;
      }
    }
    .l01 {
      .n-day {
        color: #00479d;
      }
    }
  }
}
@media only screen and (max-width: 420px) {
  .ny-news01 {
    li {
      padding: 10px 0px;
      .tu1 {
        width: 185px;
        height: 130px;
        overflow: hidden;
        border: 1px solid #efefef;
        margin-right: 30px;
        img {
          width: 185px;
          height: 130px;
          overflow: hidden;
          transition: all 0.5s ease-out;
          -webkit-transform: scale(1, 1);
          -moz-transform: scale(1, 1);
          -webkit-transition: all 0.5s ease-out;
          -moz-transition: all 0.5s ease-out;
        }
      }
      .l01 {
        margin-left: 15px;
        width: 72px;
        height: 100px;
        border-right: 1px solid #efefef;
        border-left: 1px solid #efefef;
        .n-day {
          font-size: 1.6rem;
        }
        .n-month {
          font-size: 0.8rem;
        }
      }
      .r01 {
        h2 {
          font-size: 0.8rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        p {
          font-size: 0.8rem;
          margin-top: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
    
  
     